import { useState } from "react";
import { Alert, Box, Dialog, Snackbar } from "@mui/material";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import ExoForm from "../../components/exo/ExoForm";
import { registerTenant } from "../../api/invitationApi";

const CreateTenantDialog = ({ open = false, onClose, onTenantCreated }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState(null);

  function handleSubmit(data) {
    registerTenant({
      name: data.name,
      description: data.description,
      onLoading: setIsLoading,
      onResponse: (tenant) => onTenantCreated?.(tenant),
      onError: (error) => {
        setMessage({
          severity: "error",
          text: error?.response?.data?.message || t("Organization could not be created."),
        });
      },
    });
  }

  const fields = [
    {
      label: t("Organization name"),
      type: "textBig",
      key: "name",
    },
    {
      label: t("Description"),
      type: "textBig",
      key: "description",
    },
  ];
  const validationSchema = Yup.object().shape({
    name: Yup.string().required(t("Organization name is required")),
  });

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <Box className="p-4">
          <ExoForm
            key={open ? "open" : "closed"}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            fields={fields}
            header={t("Create organization")}
            onCancle={onClose}
            isLoading={isLoading}
            submitText={t("Create")}
          />
        </Box>
      </Dialog>
      <Snackbar
        open={Boolean(message)}
        autoHideDuration={7000}
        onClose={(event, reason) => {
          if (reason === "clickaway") {
            return;
          }
          setMessage(null);
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        {message && (
          <Alert
            severity={message.severity}
            onClose={() => setMessage(null)}
          >
            {message.text}
          </Alert>
        )}
      </Snackbar>
    </>
  );
};

export default CreateTenantDialog;